import { type PlainDate, isNationalHoliday } from "@sa-nu/shared-utils/date";

/**
 * 土曜・日曜・祝日のいずれかを true で返す。
 * 日付数字の赤表示 (presentational) のみに使う。
 */
export function isHolidayDate(date: PlainDate): boolean {
  return (
    date.dayOfWeek === 6 || date.dayOfWeek === 7 || isNationalHoliday(date)
  );
}
